var htmlDataDefaults={source:"HTML",containerData:{alignment:"CENTER",width:{size:null,custom:"350"},spoiler:{enabled:null,description:null,buttonText:null},height:{custom:"550"},textWrap:!0},url:null,html:null,isAdsense:null};export{htmlDataDefaults as h};
//# sourceMappingURL=html.defaults-4d84536c.js.map
